import React, { useState, useEffect } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../../firebase-config";
import {
  CardContent,
  Box,
  Card,
} from "@mui/material";
import ReactApexChart from "react-apexcharts";

export default function SuburbsCard({ year, quarter }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [lowestPercentilePrices, setLowestPercentilePrices] = useState([]);
  const [averagePrices, setAveragePrices] = useState([]);
  const [highestPercentilePrices, setHighestPercentilePrices] = useState([]);

  async function getData({ year, quarter }) {
    setLoading(true);
    const q = query(
      collection(db, "land-prices-suburbs"),
      where("year", "==", year),
      where("quarter", "==", quarter)
    );
    const allDocs = [];
    const lowPrices = [];
    const avePrices = [];
    const highPrices = [];
    const cats = [];

    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      const docData = doc.data();
      allDocs.push(docData);
      lowPrices.push(docData["25th-percentile"]);
      avePrices.push(docData["average"]);
      highPrices.push(docData["75th-percentile"]);
      cats.push(docData["location"]);
    });

    setData(allDocs);
    setCategories(cats);
    setLowestPercentilePrices(lowPrices);
    setAveragePrices(avePrices);
    setHighestPercentilePrices(highPrices);
    setLoading(false);
  }

  useEffect(() => {
    getData({ year: year, quarter: quarter });
  }, [year, quarter]);

  return loading ? (
    <h1>Loading</h1>
  ) : data.length !== 0 ? (
    <Box
      sx={{
        mt: "10px",
      }}
    >
      <Card>
        <CardContent>
          <ReactApexChart
            options={{
              theme: {
                mode: "dark",
              },
              title: {
                text: `Land Prices in Nairobi (Q${quarter} ${year})`,
                align: "center",
                style: {
                  fontSize: "15px",
                  //   color: "#666",
                },
              },
              chart: {
                type: "bar",
                height: 500,
              },
              plotOptions: {
                bar: {
                  horizontal: false,
                },
              },
              dataLabels: {
                enabled: false,
                formatter: function (value) {
                  return "Ksh. " + value.toLocaleString();
                },
              },
              yaxis: {
                labels: {
                  formatter: function (value) {
                    return "Ksh. " + value.toLocaleString();
                  },
                },
              },
              tooltip: {
                shared: true,
                intersect: false,
              },
              stroke: {
                show: true,
                // width: 0.5,
                colors: ["#fff"],
              },
              xaxis: {
                categories: categories,
              },
            }}
            series={[
              {
                name: "25th Percentile Land Price",
                data: lowestPercentilePrices,
              },
              {
                name: "Average Land Price",
                data: averagePrices,
              },

              {
                name: "75th Percentile Land Price",
                data: highestPercentilePrices,
              },
            ]}
            height={500}
            type="bar"
          />
        </CardContent>
      </Card>
    </Box>
  ) : (
    <h6>No Land Prices Data Available For The Period</h6>
  );
}
